var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeOngoing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.313,
    height: 38.313,
    viewBox: "0 0 38.313 38.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_profile-2user",
    "data-name": "vuesax/bulk/profile-2user",
    transform: "translate(-172 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user",
    transform: "translate(172 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H38.313V38.313H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_90827",
    "data-name": "Group 90827",
    transform: "translate(-1293 -224.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M27.375,13.688A13.688,13.688,0,1,1,13.688,0,13.688,13.688,0,0,1,27.375,13.688Z",
    transform: "translate(1296.875 229.375)",
    fill: "#387f75",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M13.342,0H6.731A1.034,1.034,0,0,0,5.7,1.027,1.034,1.034,0,0,0,6.731,2.053h4.134L.3,12.62a1.033,1.033,0,0,0,0,1.451,1.024,1.024,0,0,0,1.451,0L12.315,3.5V7.638a1.027,1.027,0,0,0,2.053,0V1.027A1.034,1.034,0,0,0,13.342,0Z",
    transform: "translate(1303.719 236.219)",
    fill: "#387f75"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOngoing);
export default __webpack_public_path__ + "static/media/home-ongoing.0fa27116b117e37db07c48b54ed9ce9e.svg";
export { ForwardRef as ReactComponent };